import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import CampaignStatusPresetForm from "routes/campaign_status_presets/components/CampaignStatusPresetForm";

const CampaignStatusPresetModal = ({
  preset,
  open,
  onOpenChange,
  fetchPresets,
}) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = open !== undefined;
  const actualOpen = isControlled ? open : internalOpen;
  const setOpen = isControlled ? onOpenChange : setInternalOpen;

  const handleSuccess = () => {
    setOpen(false);
    if (fetchPresets) {
      fetchPresets();
    }
  };

  const header = `${preset ? "Edit" : "New"} Preset`;

  return (
    <Dialog open={actualOpen} onOpenChange={setOpen}>
      {!isControlled && (
        <DialogTrigger render={<Button size="sm">{header}</Button>} />
      )}
      <DialogContent>
        <DialogTitle>{header}</DialogTitle>
        <CampaignStatusPresetForm preset={preset} onSuccess={handleSuccess} />
      </DialogContent>
    </Dialog>
  );
};

export default CampaignStatusPresetModal;
